<template>
  <footer class="footer-container">
    <div class="footer-top">
      <img loading="prelaod" decoding="async" class="footer-logo" width="120" src="@/assets/logo.png" alt="surveasy">
      <div class="footer-contents">
        <div class="footer-left">
          <div class="content-gray">턴업컴퍼니 사업자 정보</div>
          <div class="content-gray">대표자: 송다예 | 사업자 등록번호:  369-16-01796</div>
          <div class="content-gray">통신판매업신고번호 제 2024-서울성동-1276호</div>
          <div class="content-gray">주소: 서울특별시 광나루로 190</div>
          <div class="content-gray">이메일 : official@gosurveasy.com</div>
          <div class="content-gray">고객센터: 0507-0178-8541</div>
        </div>
        <div class="footer-right">
          <div class="content-gray">
            다운로드
            <a href="https://play.google.com/store/apps/details?id=com.surveasy.surveasy" target="_blank" class="content-link">안드로이드</a> |
            <a href="https://apps.apple.com/kr/app/%EC%84%9C%EB%B2%A0%EC%9D%B4%EC%A7%80/id1614071000" target="_blank" class="content-link">iOS</a>
          </div>
          <div class="content-gray">
            <a href="https://surveasy.oopy.io/terms-of-use" target="_blank" class="content-link">이용약관</a> | <a href="https://surveasy.oopy.io/privacy-policy" target="_blank" class="content-link">개인정보처리방침</a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <span class="content-gray">© 2026 Surveasy</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterContainer'
}
</script>

<style scoped>
.footer-container {
  width: 100%;
  font-family: var(--font-sans);
  background-color: var(--bg-page);
  box-sizing: border-box;
  padding: 32px 20px 0;
}

.footer-top {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 700px;
  margin: 0 auto;
}

.footer-logo {
  margin-bottom: 20px;
}

.footer-contents {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
}

.footer-left,
.footer-right {
  display: flex;
  flex-direction: column;
}

.footer-right {
  align-items: flex-start;
}

.content-gray {
  text-align: left;
  font-size: 13px;
  color: var(--text-muted);
  margin-bottom: 8px;
}

.content-link {
  color: var(--text-muted);
}

.footer-bottom {
  max-width: 700px;
  margin: 12px auto 0;
  padding: 16px 0;
  border-top: 1px solid var(--ink-100);
  text-align: left;
}

.footer-bottom .content-gray {
  margin-bottom: 0;
}

@media (max-width: 480px) {
  .footer-contents {
    flex-direction: column;
  }
}

@media (min-width: 900px) {
  .footer-top,
  .footer-bottom {
    max-width: 1200px;
  }
}
</style>
